module.exports = __webpack_public_path__ + "download/img/download.2a4297bd.png";